<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     激活二维码
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    class="qrcode-active"
    width="600px"
    title="激活二维码"
    :visible.sync="dialogShow"
    append-to-body
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <div style="height: 350px;">
      <template v-if="step == 1">
        <el-form v-loading="posting" ref="activeForm" :model="activeForm" :rules="activeRules" label-position="left" label-width="100px" style="padding: 30px 50px 60px;">
          <el-form-item label="起始序列" prop="start_serial_no">
            <el-input v-model="activeForm.start_serial_no" />
          </el-form-item>
          <el-form-item label="结束序列" prop="end_serial_no">
            <el-input v-model="activeForm.end_serial_no" />
          </el-form-item>
          <el-form-item label="关联商品" prop="productid">
            <product-selector v-model="activeForm.productid" placeholder="" style="width: 100%;" />
          </el-form-item>
          <el-form-item label="生产日期">
            <f-date-picker v-model="activeForm.product_date" :shortcuts="[-90, -30, 0, 90, 30]" clearable style="width: 100%;" />
          </el-form-item>
          <el-form-item label="生产批次" prop="product_batch">
            <el-input v-model="activeForm.product_batch" />
          </el-form-item>
        </el-form>
      </template>

      <div v-if="step == 2" class="flex-center column mb-hg">
        <i class="el-icon-success text-success font-12x"></i>
        <div class="mt-lg font-md">激活成功 <span class="text-primary">{{ success_count }}</span> 个<span v-if="fail_count">，失败 <span class="text-danger">{{ fail_count }}</span> 个</span></div>
      </div>
    </div>

    <div slot="footer" class="flex-center mb">
      <el-button v-if="step == 1" class="extend" @click="dialogShow = false">取消</el-button>
      <el-button v-if="step == 1" class="extend" type="primary" :loading="posting" @click="submit">确定</el-button>
      <el-button v-if="step == 2" class="extend" @click="dialogShow = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { codeActiveApi } from "@/api/fam/famCodeApi";
import { validateNumber } from "@/utils/validate";

export default {
  name: 'QrcodeActive',

  components: {
    ProductSelector: () => import('./ProductSelector.vue'),
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    var validateNo = (rule, value, callback) => {
      value = +value
      if (!value) {
        callback(new Error('请输入正确的序列！'))
      } else {
        if (validateNumber(value)) {
          if (value > 100000) return callback(new Error('请输入正确的序列！'))
          if (this.activeForm.start_serial_no && this.activeForm.end_serial_no && +this.activeForm.start_serial_no > +this.activeForm.end_serial_no) {
            return callback(new Error('起始序列应小于等于结束序列！'))
          }
          callback()
        } else {
          return callback(new Error('请输入正确的序列！'))
        }
      }
    }

    return {
      step: 1,
      success_count: 0,
      fail_count: 0,
      posting: false,
      activeForm: {
        start_serial_no: null,
        end_serial_no: null,
        productid: null,
        product_date: null,
        product_batch: ''
      },

      activeRules: {
        start_serial_no: [
          { required: true, message: "起始序列不能为空", trigger: "blur" },
          { validator: validateNo, trigger: "blur" }
        ],
        end_serial_no: [
          { required: true, message: "结束序列不能为空", trigger: "blur" },
          { validator: validateNo, trigger: "blur" }
        ],
        productid: [
          { required: true, message: "关联商品不能为空", trigger: "change" }
        ],
      }
      
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  created() {
  },

  methods: {
    submit() {
      this.$refs['activeForm'].validate(valid => {
        if (valid) {
          this.posting = true
          codeActiveApi(this.activeForm).then((res) => {
            this.posting = false
            if (res.errno === 0) {
              this.success_count = res.data.success_count
              this.fail_count = res.data.fail_count
              this.step = 2
              this.$emit('success')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    clear() {
      this.$nextTick(() => {
        this.$refs['activeForm'].clearValidate()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
